import '../app-config/app-config.js';
import { getBootFlag, BootFlags } from '../app-config/boot-flags.js';
import '../app-config/build-data.js';
import { getTenantNamespace } from '../app-config/tenant.js';
import 'react';
import '../authentication/AuthenticationContextProvider.js';
import { useAuth, useIsServiceAccountUser } from '../authentication/permissions.js';
import { logError } from '../errors/error-reporting.js';
import 'urql';
import '@tanstack/react-query';
import 'lodash-es';

function chameleonAllowed() {
    const chameleonMode = getBootFlag(BootFlags.CHAMELEON_MODE);
    return chameleonMode === 'enabled';
}
function appendChameleonScript() {
    // Intentionally controlling the script injection ourselves instead of using the npm package, so we
    // retain the ability to turn it off via feature flags in case something goes wrong.
    try {
        const tenant = getTenantNamespace();
        if (!chameleonAllowed()) {
            return;
        }
        const SCRIPT_TAG_ID = `chameleon-${tenant}`;
        if (document.getElementById(SCRIPT_TAG_ID) !== null) {
            return;
        }
        const script = document.createElement('script');
        script.id = SCRIPT_TAG_ID;
        script.type = 'text/javascript';
        script.appendChild(document.createTextNode(SCRIPT_CONTENTS));
        document.body.appendChild(script);
    } catch (e) {
        console.error(e);
    }
}
const SCRIPT_CONTENTS = `!function(d,w){var t="Sj4ygzPHEbcsbayqH0QWtCThImBqcMNLkHlXI3gSUmOyDl-1OywYa-DTRlB4JJj8xOa1BY",c="chmln",i=d.createElement("script");if(w[c]||(w[c]={}),!w[c].root){w[c].accountToken=t,w[c].location=w.location.href.toString(),w[c].now=new Date,w[c].fastUrl='https://fast.chameleon.io/';var m="identify alias track clear set show on off custom help _data".split(" ");for(var s=0;s<m.length;s++){!function(){var t=w[c][m[s]+"_a"]=[];w[c][m[s]]=function(){t.push(arguments);};}();}i.src=w[c].fastUrl+"messo/"+t+"/messo.min.js",i.async=!0,d.head.appendChild(i);}}(document,window);`;
function useChameleon() {
    const { currentUser } = useAuth();
    const isServiceAccount = useIsServiceAccountUser();
    if (!chameleonAllowed()) {
        return;
    }
    const chameleon = window.chmln;
    if (chameleon !== null && chameleon !== undefined && Boolean(currentUser?.email) && isServiceAccount === false) {
        try {
            const tenant = getTenantNamespace();
            chameleon.identify(currentUser?.id ?? '', {
                email: currentUser?.email ?? '',
                isSysAdmin: currentUser?.isAdmin ?? false,
                tenantName: tenant
            });
        } catch (error) {
            logError(error);
        }
    }
}

export { appendChameleonScript, useChameleon };
//# sourceMappingURL=chameleon.js.map
